'use client';

import Icon from '@/components/ui/icons/Icon';
import * as React from 'react';

interface ActionButtonProps {
  label: string;
  onClick?: () => void;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ label, onClick }) => {
  return (
    <button onClick={onClick} className='group flex gap-3 justify-center items-center pr-1.5 pl-5 bg-dark-900 transition-colors duration-300 ease-out hover:bg-dark-800 min-h-10 rounded-[999px]' aria-label={label}>
      <span className='self-stretch my-auto text-body-md font-fractul text-white'>{label}</span>
      <div className='flex gap-2.5 justify-center items-center self-stretch my-auto w-8 h-8 bg-white min-h-8 rounded-[999px]'>
        <Icon name='arrow-right' className='text-grey-900 size-5 transform duration-300 ease-out group-hover:translate-x-[2px] group-hover:text-dark-800' />
      </div>
    </button>
  );
};
